import { takeLatest, put } from 'redux-saga/effects';
import { apiCall } from './network';
import {
  GET_REGISTRATIONS,
  UPDATE_REGISTRATION,
  ADD_NEW_REGISTRATION,
  DELETE_REGISTRATION
} from '../names';
import { AnyAction } from 'redux';
import {
  setRegistrations,
} from 'reduxStore/actions/registrations';
import { toast } from 'react-toastify';
import * as R from 'ramda';
import { t } from 'I18n';

const URL = '/api/registrations';

function* getRegistrations(action: AnyAction) {
  const headers = {
    'Content-Type': 'application/json'
  };
  const url = `${URL}${action.payload}`;

  try {
    const res = yield apiCall(url, 'GET', headers);
    const response = yield res.json();
    yield put(setRegistrations(response));
  } catch (error) {
    console.error(error);
  }
}

function* updateRegistration(action: AnyAction) {
  const headers = {
    'Content-Type': 'application/json'
  };
  const url = `${URL}/${action.payload.id}`;

  try {
    yield apiCall(url, 'PUT', headers, JSON.stringify(action.payload.data));
    action.payload.onSuccess();

    toast.success(t('int.registration-updated-successfully'));
  } catch (error) {
    const err = yield error.json();
    const errors = Object.keys(err.fieldErrors);
    errors.forEach(key => {
      toast.error(
        `${t(
          R.pathOr('int.an-error-has-occurred', ['fieldErrors', key], err)
        )} ${t(key)}`
      );
    });
  }
}

function* addNewRegistration(action: AnyAction) {
  const headers = {
    'Content-Type': 'application/json'
  };
  const url = `${URL}`;

  try {
    yield apiCall(url, 'POST', headers, JSON.stringify(action.payload));
    action.payload.onSuccess();

    toast.success(t('int.registration-added-successfully'));
  } catch (error) {
    const err = yield error.json();
    const errors = Object.keys(err.fieldErrors);
    errors.forEach(key => {
      toast.error(
        `${t(
          R.pathOr('int.an-error-has-occurred', ['fieldErrors', key], err)
        )} ${t(key)}`
      );
    });
  }
}

function* deleteRegistration(action: AnyAction) {
  const headers = {
    'Content-Type': 'application/json'
  };
  const url = `${URL}/${action.payload.id}`;

  try {
    yield apiCall(url, 'DELETE', headers);
    action.payload.onSuccess();

    toast.success(t('int.registration-deleted-successfully'));
  } catch (error) {
    const err = yield error.json();
    if (err?.error) {
      toast.error(t(err.error));
    }
  }
}

function* registrationWatcher() {
  yield takeLatest(GET_REGISTRATIONS, getRegistrations);
  yield takeLatest(UPDATE_REGISTRATION, updateRegistration);
  yield takeLatest(ADD_NEW_REGISTRATION, addNewRegistration);
  yield takeLatest(DELETE_REGISTRATION, deleteRegistration);
}

export default registrationWatcher;
